export const t = text => globalThis.AW_I18N?.[text] || text;
export const format = (text, ...values) => { let n=0; return t(text).replace(/%[sd]/g, () => String(values[n++] ?? '')); };
